/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Image assets for tenant
 */
export interface TenantImageAssetUrls {
  logoUrl: string;
  logoLargeUrl: string;
  logoWatermarkUrl: string;
  navbarIconUrl: string;
  fallbackModuleImageUrl: string;
}
